import { render } from "./reply_button.vue?vue&type=template&id=03d9209d"
import script from "./reply_button.js?vue&type=script&lang=js"
export * from "./reply_button.js?vue&type=script&lang=js"

import "./reply_button.vue?vue&type=style&index=0&id=03d9209d&lang=scss"

import exportComponent from "/builds/pleroma/pleroma-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__